import { generateClient } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';
import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

const client = generateClient();

export const getPathfinderACCSDomainKeyByIndex = (index) => {
  const domainKeys = [
    "MSRA: Clinical Problem Solving",
    "MSRA: Professional Dilemmas",
    "Interview: Commitment to Specialty",
    "Interview: Teamwork & Stress",
    "Interview: Teaching & QI",
    "Interview: EM Knowledge",
    "Interview: Clinical Scenarios"
  ];
  
  const numericIndex = Number(index);
  if (isNaN(numericIndex)) {
    return `Unknown domain ${index}`;
  }
  
  return domainKeys[numericIndex] || `Unknown domain ${index}`;
};

const isNumericDomainKey = (key) => {
  return !isNaN(Number(key)) && key !== null && key !== '';
};

export const savePathfinderACCSDomainScore = async (domainKey, points) => {
  try {
    const textDomainKey = isNumericDomainKey(domainKey) 
      ? getPathfinderACCSDomainKeyByIndex(Number(domainKey))
      : domainKey;
    
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    console.log(`Saving PathfinderACCSDomainScore: domainKey="${textDomainKey}", points=${points}`);

    const { data } = await client.graphql({
      query: queries.listPathfinderACCSDomainScores,
      variables: {
        filter: { 
          userId: { eq: user.username }, 
          domainKey: { eq: textDomainKey }
        }
      },
      authMode: 'userPool'
    });

    const existingRecord = data.listPathfinderACCSDomainScores.items[0];

    if (existingRecord) {
      const input = {
        id: existingRecord.id,
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username,
        _version: existingRecord._version
      };

      console.log('Updating existing ACCS record with input:', input);
      const result = await client.graphql({
        query: mutations.updatePathfinderACCSDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      console.log('ACCS Update successful:', result);
      return result;
    } else {
      const input = {
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username
      };

      console.log('Creating new ACCS record with input:', input);
      const result = await client.graphql({
        query: mutations.createPathfinderACCSDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      console.log('ACCS Create successful:', result);
      return result;
    }
  } catch (error) {
    console.error('Error saving Pathfinder ACCS domain score:', error);
    throw error;
  }
};

export const fetchAllPathfinderACCSDomainScores = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    const { data } = await client.graphql({
      query: queries.listPathfinderACCSDomainScores,
      variables: {
        filter: { userId: { eq: user.username } },
        limit: 100
      },
      authMode: 'userPool'
    });

    return data.listPathfinderACCSDomainScores.items;
  } catch (error) {
    console.error('Error fetching Pathfinder ACCS domain scores:', error);
    return [];
  }
};

